/* istanbul ignore file */

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { environment } from '../../../environments/environment';
import { AuthUser } from '../../models';

@Injectable({
    providedIn: 'root'
})
export class AuthDataService extends HttpBaseService {

    private route = environment.api;

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    loginUserAPI(adToken: string): Observable<AuthUser> {
        const url = `${this.route}authenticate`;
        this._httpHeaders = new HttpHeaders({ Authorization: `Bearer ${adToken}` });
        return this.httpGet(url);
    }

}
